import React from 'react';
import {
  RadioOption,
  RadioInput,
} from './DynamicQuestionForm/DynamicQuestionForm.styled';

interface StatusOption {
  value: string;
  label: string;
  count: string | number;
}

interface StatusFilterProps {
  statusOptions: StatusOption[];
  selectedStatus: string;
  onStatusChange: (status: string) => void;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  statusOptions,
  selectedStatus,
  onStatusChange,
}) => {
  return (
    <>
      {statusOptions.map(option => (
        <RadioOption key={option.value} $variant="black">
          <RadioInput
            type="radio"
            name="statusFilter"
            value={option.value}
            checked={selectedStatus === option.value}
            onChange={() => onStatusChange(option.value)}
          />
          <span className="text-gray-600 text-sm">
            {option.label} <span>({option.count})</span>
          </span>
        </RadioOption>
      ))}
    </>
  );
};

export default StatusFilter;
